"use client";
import React, { useState } from "react";
import { TabItem } from "../../data/types";
import AppFraudDisclaimer from "./LegalPages/AppFraudDisclaimer";
import CardsTermsAndConditionsOrenda from "./LegalPages/CardsTermsAndConditionsOrenda";
import ComplaintsProcess from "./LegalPages/ComplaintsProcess";
import ConfirmationOfPayee from "./LegalPages/ConfirmationOfPayee";
import CookiePolicy from "./LegalPages/CookiePolicy";
import Disclaimer from "./LegalPages/Disclaimer";
import FraudFaqs from "./LegalPages/Fraud-Faqs";
import GlossaryTerms from "./LegalPages/GlossaryTerms";
import OrendaFees from "./LegalPages/OrendaFees";
import PrivacyPolicy from "./LegalPages/PrivacyPolicy";
import TermsAndConditionsMonavate from "./LegalPages/TermsAndConditionsMonavate";
import TermsAndConditionsOrenda from "./LegalPages/TermsAndConditionsOrenda";
import VisaExchangeRateCalc from "./LegalPages/VisaExchangeRateCalc";
import VisaSecureFaq from "./LegalPages/VisaSecureFaq";
import { TabDropdown } from "./TabDropdown";
import { TabList } from "./TabList";

const LegalPage: React.FC = () => {
  const tabs: TabItem[] = [
    { id: "privacy", label: "Privacy Policy" },
    { id: "cookie", label: "Cookie Policy" },
    { id: "disclaimer", label: "Disclaimer" },
    { id: "Fraud Faqs", label: "Fraud FAQs" },
    { id: "App Fraud Disclaimer", label: "App Fraud Disclaimer" },
    { id: "Confirmation of Payee", label: "Confirmation of Payee" },
    { id: "Complaints Process", label: "Complaints Process" },
    { id: "Glossary of Terms", label: "Glossary of Terms" },
    { id: "Orenda Fees", label: "Orenda Fees" },
    // { id: "termsMonavate", label: "T&C Monavate" },
    { id: "VisaExchangeRateCalculator", label: "Visa Exchange Rate Calculator" },
    { id: "VisaSecureFaqs", label: "Visa Secure FAQs" },
    { id: "termsOrenda", label: "T&C Orenda" },
    { id: "cardsTermsOrenda", label: "Cards T&C Orenda" },
  ];

  const [selectedTab, setSelectedTab] = useState(tabs[0].id);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const renderSelectedPage = () => {
    switch (selectedTab) {
      case "privacy":
        return <PrivacyPolicy />;
      case "cookie":
        return <CookiePolicy />;
      case "disclaimer":
        return <Disclaimer />;
      case "Fraud Faqs":
        return <FraudFaqs />;
      case "App Fraud Disclaimer":
        return <AppFraudDisclaimer />;
      case "Confirmation of Payee":
        return <ConfirmationOfPayee />;
      case "Complaints Process":
        return <ComplaintsProcess />;
      case "Glossary of Terms":
        return <GlossaryTerms />;
      case "Orenda Fees":
        return <OrendaFees />;
      // case "termsMonavate":
      //   return <TermsAndConditionsMonavate />;
      case "VisaExchangeRateCalculator":
        return <VisaExchangeRateCalc />;
      case "VisaSecureFaqs":
        return <VisaSecureFaq />;
      case "termsOrenda":
        return <TermsAndConditionsOrenda />;
      case "cardsTermsOrenda":
        return <CardsTermsAndConditionsOrenda />;
      default:
        return <PrivacyPolicy />;
    }
  };

  return (
    <>
      {/* Add a full-width 40px height bg-slate-800 bar */}
      <div className="w-full h-20 bg-slate-900"></div>
      <main className="flex flex-col items-center">
        <section className="w-full bg-gray-200 pt-28">
          <div className="container">
            <h1 className="text-3xl font-extrabold text-gray-900">Legal</h1>
            <p className="mt-4 text-gray-700">Transparency is a recurring FinVue value reflected in our pricing promise, security protocol, and legal agreements.</p>
            <div className="mt-6">
              <div className="hidden md:block">
                {/* Desktop Tabs */}
                <TabList items={tabs} selectedTab={selectedTab} onSelect={setSelectedTab} />
              </div>
              <div className="block md:hidden mb-2">
                {/* Mobile Dropdown */}
                <TabDropdown items={tabs} selectedTab={selectedTab} onSelect={setSelectedTab} isOpen={isDropdownOpen} onToggle={() => setIsDropdownOpen(!isDropdownOpen)} />
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="mt-8">{renderSelectedPage()}</div>
        </section>
      </main>
    </>
  );
};

export default LegalPage;
